import React from "react";

function Contact() {
  return (
    <div>
      <h1>Контакты</h1>
      <form>
        <label>
          Имя:
          <input type="text" name="name" />
        </label>
        <br />
        <label>
          Email:
          <input type="email" name="email" />
        </label>
        <br />
        <label>
          Сообщение:
          <textarea name="message"></textarea>
        </label>
        <br />
        <button type="submit">Отправить</button>
      </form>
    </div>
  );
}

export default Contact;
